export default __webpack_public_path__ + "static/media/magic_star.8314df3c.svg";